@if (type === 'overlay') {
  <div class="toolbox-overlay">
    <div [ngClass]='["background", type]'></div>
    <div #editor
      class="text-toolbox"
      [style.maxHeight]="heightOverride"
      [style.transform]="hostElementTransformation"
      [style.opacity]="hostElementOpacity"
      [style.transition]="hostElementTransition">
    <mat-card [ngClass]='["toolbox", type,
                          displayTitle ? "w-title" : "wo-title"]'>
        <mat-card-header>
          @if (displayTitle) {
            <mat-card-title>
              {{ 'i18n.toolbox.text.title' | translate }}
            </mat-card-title>
          }
          <mat-icon svgIcon="close"
            class="close-x"
          (click)="btnCancelClick()"></mat-icon>
        </mat-card-header>
        <mat-card-content>
          <text-editor #textEditor
            [placeholder]="placeholder"
            (editingResponse)="editingResponse($event)"
          ></text-editor>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
}
